import { motion } from "framer-motion";
import { Kicker } from "@/components/Bits";
import { maskChild, staggerParent, scaleIn } from "@/lib/motion";
import { CtaRow } from "@/components/CTAButtons";

export const PageHero = ({ kicker, lines = [], sub, image, showCta = true }) => (
  <section className="relative flex min-h-[68vh] items-end overflow-hidden bg-charcoal">
    <motion.div variants={scaleIn} initial="hidden" animate="show" className="absolute inset-0">
      <img src={image} alt={lines.join(" ")} className="h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/45 to-black/25" />
    </motion.div>
    <div className="relative mx-auto w-full max-w-[1400px] px-5 pb-14 pt-36 md:px-10 md:pb-20">
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <Kicker tone="yellow">{kicker}</Kicker>
      </motion.div>
      <motion.h1 variants={staggerParent} initial="hidden" animate="show" className="mt-5 font-display text-6xl uppercase leading-[0.85] tracking-tight text-white sm:text-7xl lg:text-8xl">
        {lines.map((line, i) => (
          <span key={i} className="mask-reveal">
            <motion.span variants={maskChild} custom={i} className="block">
              {line}
            </motion.span>
          </span>
        ))}
      </motion.h1>
      {sub && (
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.55, duration: 0.6 }} className="mt-6 max-w-2xl font-body text-base leading-relaxed text-white/85 md:text-lg">
          {sub}
        </motion.p>
      )}
      {showCta && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.7, duration: 0.6 }} className="mt-8">
          <CtaRow onDark />
        </motion.div>
      )}
    </div>
  </section>
);
